<template>
    <home endpoint="productclass" :params="params"></home>
</template>

<script>
import home from '@/components/tools/Index'
export default {
  name: 'productclass',
  components: {
    home,
  },
  data () {
    return {
      params: {
        fields: [
          {name: 'id', label: 'Código', required: true},
          {name: 'Name', label: 'Nombre', required: true},
          {name: 'Closed', label: 'Cerrado', editor: 'checkbox'}],
        title: 'Tipos de Producto',
        title2: 'Tipos de Productos'
      }
    }
  },
}
</script>

